/* Vercony balcony PHOTO check
   Upload railing photo -> Cloudflare Worker (vision) -> verdict rendered here.
   The Worker only returns a category; all copy lives here so it stays 4-lingual. */
(function () {
  'use strict';

  var STRINGS = {
    nl: {
      title: 'Past dit op jouw hekwerk?',
      sub: 'Upload een foto van je hekwerk — we checken direct of onze plantenbak past.',
      uploadBtn: 'Foto uploaden',
      privacy: 'Je foto wordt alleen voor deze check gebruikt en niet opgeslagen.',
      analyzing: 'We bekijken je hekwerk…',
      cta: 'In winkelwagen',
      retry: 'Andere foto proberen',
      pass_title: 'Gelukt — dit past op jouw hekwerk! 🎉',
      pass_text: 'Je hekwerk heeft verticale spijlen. Onze plantenbak schuift daar eenvoudig tussen — hij past. Tip: controleer even of de spijlen rond of vierkant zijn en max 3,5 cm dik, met genoeg ruimte ertussen.',
      no_title: 'Dit past helaas niet',
      glass_text: 'Je balustrade lijkt van glas of een dicht paneel. Onze plantenbak heeft verticale spijlen nodig om tussen te schuiven.',
      horizontal_text: 'Je reling lijkt alleen horizontale spijlen te hebben. Onze plantenbak heeft verticale spijlen nodig om tussen te schuiven.',
      unclear_title: 'We konden het niet goed zien',
      unclear_text: 'Probeer een foto recht van voren op je hekwerk, met goed licht.',
      error_title: 'Er ging even iets mis',
      error_text: 'Controleer je internetverbinding en probeer het opnieuw.',
      ornamental_text: 'Je reling heeft sierlijke of gebogen spijlen (krullen of ornamenten). Onze plantenbak past alleen op rechte, gladde spijlen.',
      wide_text: 'Je reling heeft brede of platte spijlen met te weinig ruimte ertussen. Onze plantenbak past alleen op smalle spijlen met genoeg ruimte om ertussen te schuiven.',
      limit_title: 'Je hebt de check 3× gedaan',
      limit_text: 'Je kunt de check maximaal 3 keer per dag doen. Twijfel je nog? Neem gerust contact met ons op.',
      rate_title: 'Het is nu even druk',
      rate_text: 'Er worden op dit moment veel checks gedaan. Probeer het over een minuutje opnieuw.'
    },
    fr: {
      title: 'Est-ce que ça convient à votre balustrade ?',
      sub: 'Téléchargez une photo de votre balustrade — nous vérifions aussitôt si notre jardinière convient.',
      uploadBtn: 'Télécharger une photo',
      privacy: 'Votre photo sert uniquement à cette vérification et n’est pas conservée.',
      analyzing: 'Nous analysons votre balustrade…',
      cta: 'Ajouter au panier',
      retry: 'Essayer une autre photo',
      pass_title: 'Parfait — ça convient à votre balustrade ! 🎉',
      pass_text: 'Votre balustrade a des barreaux verticaux. Notre jardinière se glisse simplement entre les barreaux — elle convient. Astuce : vérifiez que les barreaux sont ronds ou carrés, max 3,5 cm d’épaisseur, avec assez d’espace entre eux.',
      no_title: 'Cela ne convient malheureusement pas',
      glass_text: 'Votre balustrade semble en verre ou en panneau plein. Notre jardinière a besoin de barreaux verticaux pour s’y glisser.',
      horizontal_text: 'Votre balustrade semble n’avoir que des barreaux horizontaux. Notre jardinière a besoin de barreaux verticaux.',
      unclear_title: 'Nous n’avons pas bien vu',
      unclear_text: 'Essayez une photo bien de face de votre balustrade, avec une bonne lumière.',
      error_title: 'Un problème est survenu',
      error_text: 'Vérifiez votre connexion internet et réessayez.',
      ornamental_text: 'Votre balustrade a des barreaux décoratifs ou courbés (volutes ou ornements). Notre jardinière ne convient qu’aux barreaux droits et lisses.',
      wide_text: 'Votre balustrade a des barreaux larges ou plats avec trop peu d’espace entre eux. Notre jardinière ne convient qu’aux barreaux fins avec assez d’espace pour se glisser entre eux.',
      limit_title: 'Vous avez fait le test 3 fois',
      limit_text: 'Le test est limité à 3 fois par jour. Un doute ? Contactez-nous.',
      rate_title: 'Beaucoup de trafic en ce moment',
      rate_text: 'De nombreux tests sont en cours. Réessayez dans une minute.'
    },
    de: {
      title: 'Passt das auf dein Geländer?',
      sub: 'Lade ein Foto deines Geländers hoch — wir prüfen sofort, ob unser Pflanzkasten passt.',
      uploadBtn: 'Foto hochladen',
      privacy: 'Dein Foto wird nur für diese Prüfung verwendet und nicht gespeichert.',
      analyzing: 'Wir schauen uns dein Geländer an…',
      cta: 'In den Warenkorb',
      retry: 'Anderes Foto versuchen',
      pass_title: 'Super — das passt auf dein Geländer! 🎉',
      pass_text: 'Dein Geländer hat senkrechte Streben. Unser Pflanzkasten lässt sich einfach dazwischenschieben — er passt. Tipp: Prüfe kurz, ob die Streben rund oder quadratisch und max. 3,5 cm dick sind, mit genug Abstand dazwischen.',
      no_title: 'Das passt leider nicht',
      glass_text: 'Dein Geländer scheint aus Glas oder einem geschlossenen Paneel zu bestehen. Unser Pflanzkasten braucht senkrechte Streben zum Einschieben.',
      horizontal_text: 'Dein Geländer scheint nur waagerechte Streben zu haben. Unser Pflanzkasten braucht senkrechte Streben zum Einschieben.',
      unclear_title: 'Wir konnten es nicht gut erkennen',
      unclear_text: 'Versuche ein Foto frontal auf dein Geländer bei gutem Licht.',
      error_title: 'Etwas ist schiefgelaufen',
      error_text: 'Prüfe deine Internetverbindung und versuche es erneut.',
      ornamental_text: 'Dein Geländer hat verzierte oder geschwungene Streben (Ornamente). Unser Pflanzkasten passt nur auf gerade, glatte Streben.',
      wide_text: 'Dein Geländer hat breite oder flache Streben mit zu wenig Abstand dazwischen. Unser Pflanzkasten passt nur auf schmale Streben mit genug Platz zum Einschieben.',
      limit_title: 'Du hast den Check 3× gemacht',
      limit_text: 'Der Check ist auf 3 Mal pro Tag begrenzt. Noch unsicher? Kontaktiere uns gern.',
      rate_title: 'Gerade ist viel los',
      rate_text: 'Es werden momentan viele Checks durchgeführt. Versuche es in einer Minute erneut.'
    },
    en: {
      title: 'Does this fit your railing?',
      sub: 'Upload a photo of your railing — we’ll check right away whether our planter fits.',
      uploadBtn: 'Upload photo',
      privacy: 'Your photo is only used for this check and is not stored.',
      analyzing: 'Analysing your railing…',
      cta: 'Add to cart',
      retry: 'Try another photo',
      pass_title: 'Great — this fits your railing! 🎉',
      pass_text: 'Your railing has vertical bars. Our planter simply slides between them — it fits. Tip: check that the bars are round or square, max 3.5 cm thick, with enough space between them.',
      no_title: 'This doesn’t fit, unfortunately',
      glass_text: 'Your railing looks like glass or a solid panel. Our planter needs vertical bars to slide between.',
      horizontal_text: 'Your railing appears to have only horizontal bars. Our planter needs vertical bars to slide between.',
      unclear_title: 'We couldn’t see it clearly',
      unclear_text: 'Try a photo taken straight-on of your railing, in good light.',
      error_title: 'Something went wrong',
      error_text: 'Check your connection and try again.',
      ornamental_text: 'Your railing has decorative or curved bars (scrolls or ornaments). Our planter only fits plain, straight bars.',
      wide_text: 'Your railing has wide or flat bars with too little space between them. Our planter only fits narrow bars with enough gap to slide between.',
      limit_title: 'You’ve done the check 3×',
      limit_text: 'The check is limited to 3 times per day. Still unsure? Feel free to contact us.',
      rate_title: 'It’s busy right now',
      rate_text: 'A lot of checks are running at the moment. Please try again in a minute.'
    },
    es: {
      title: '¿Esto encaja en tu barandilla?',
      sub: 'Sube una foto de tu barandilla — comprobamos al instante si nuestra jardinera encaja.',
      uploadBtn: 'Subir foto',
      privacy: 'Tu foto solo se usa para esta comprobación y no se guarda.',
      analyzing: 'Estamos analizando tu barandilla…',
      cta: 'Añadir al carrito',
      retry: 'Probar con otra foto',
      pass_title: '¡Genial — encaja en tu barandilla! 🎉',
      pass_text: 'Tu barandilla tiene barrotes verticales. Nuestra jardinera se desliza fácilmente entre ellos — encaja. Consejo: comprueba que los barrotes sean redondos o cuadrados, de máximo 3,5 cm de grosor, con suficiente espacio entre ellos.',
      no_title: 'Lamentablemente, esto no encaja',
      glass_text: 'Tu barandilla parece de cristal o un panel macizo. Nuestra jardinera necesita barrotes verticales para deslizarse entre ellos.',
      horizontal_text: 'Tu barandilla parece tener solo barrotes horizontales. Nuestra jardinera necesita barrotes verticales para deslizarse entre ellos.',
      unclear_title: 'No hemos podido verlo bien',
      unclear_text: 'Prueba con una foto tomada de frente a tu barandilla, con buena luz.',
      error_title: 'Algo ha ido mal',
      error_text: 'Comprueba tu conexión a internet e inténtalo de nuevo.',
      ornamental_text: 'Tu barandilla tiene barrotes decorativos o curvados (volutas u ornamentos). Nuestra jardinera solo encaja en barrotes rectos y lisos.',
      wide_text: 'Tu barandilla tiene barrotes anchos o planos con muy poco espacio entre ellos. Nuestra jardinera solo encaja en barrotes estrechos con suficiente espacio para deslizarse entre ellos.',
      limit_title: 'Has hecho la comprobación 3 veces',
      limit_text: 'La comprobación está limitada a 3 veces al día. ¿Sigues teniendo dudas? No dudes en contactarnos.',
      rate_title: 'Ahora mismo hay mucho tráfico',
      rate_text: 'Se están realizando muchas comprobaciones en este momento. Inténtalo de nuevo dentro de un minuto.'
    }
  };

  // category -> { icon, pass, titleKey, textKey }
  var VERDICTS = {
    vertical_bars: { icon: '✅', pass: true, title: 'pass_title', text: 'pass_text' },
    ornamental: { icon: '❌', pass: false, title: 'no_title', text: 'ornamental_text' },
    wide_slats: { icon: '❌', pass: false, title: 'no_title', text: 'wide_text' },
    glass_solid: { icon: '❌', pass: false, title: 'no_title', text: 'glass_text' },
    horizontal_only: { icon: '❌', pass: false, title: 'no_title', text: 'horizontal_text' },
    unclear: { icon: '🔄', pass: false, title: 'unclear_title', text: 'unclear_text' },
    error: { icon: '⚠️', pass: false, title: 'error_title', text: 'error_text' },
    limit: { icon: '🔒', pass: false, title: 'limit_title', text: 'limit_text' },
    rate: { icon: '⏳', pass: false, title: 'rate_title', text: 'rate_text' }
  };

  var MAX_DIM = 1024; // longest edge sent to the Worker (1024 lets the model resolve
                      // thin bars below a decorative top band, e.g. Parisian railings;
                      // it only downscales large photos, never upscales small ones)
  var JPEG_QUALITY = 0.85;
  var MAX_PER_USER = 0; // per-visitor daily cap (localStorage). 0 = uit (vrij testen); zet op 3 vóór live.

  // Per-visitor usage counter, reset each UTC day. Client-side only (a soft
  // guard on top of the Worker's global daily cap + rate limiter).
  function usageKey() { return 'bpc_uses_' + new Date().toISOString().slice(0, 10); }
  function getUses() {
    try { return parseInt(localStorage.getItem(usageKey()) || '0', 10) || 0; } catch (e) { return 0; }
  }
  function bumpUses() {
    try { localStorage.setItem(usageKey(), String(getUses() + 1)); } catch (e) {}
  }

  // GA4 — route through the theme's Route B pipeline (soft-conversions.js exposes
  // window.VerconySC.track), so events inherit the same consent handling.
  function gaEvent(name, params) {
    try {
      if (window.VerconySC && typeof window.VerconySC.track === 'function') {
        window.VerconySC.track(name, params || {});
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', name, params || {});
      }
    } catch (e) {}
  }
  function fitsLabel(cat) {
    if (cat === 'vertical_bars') return 'fits';
    if (cat === 'unclear' || cat === 'error' || cat === 'rate') return 'uncertain';
    return 'not_fits';
  }

  function init(modal) {
    if (modal.dataset.bpcReady) return;
    modal.dataset.bpcReady = '1';

    var lang = modal.getAttribute('data-bpc-lang') || 'en';
    var t = STRINGS[lang] || STRINGS.en;
    var endpoint = (modal.getAttribute('data-bpc-endpoint') || '').trim();
    var product = {
      id: modal.getAttribute('data-bpc-product-id') || '',
      name: modal.getAttribute('data-bpc-product-name') || ''
    };

    // Trigger buttons may live anywhere on the page (e.g. inside the product
    // description), so bind every [data-bpc-open] rather than a scoped one.
    var triggers = document.querySelectorAll('[data-bpc-open]');
    var fileInput = modal.querySelector('[data-bpc-file]');
    var previews = modal.querySelectorAll('[data-bpc-preview]');
    var steps = {
      intro: modal.querySelector('[data-bpc-step="intro"]'),
      loading: modal.querySelector('[data-bpc-step="loading"]'),
      result: modal.querySelector('[data-bpc-step="result"]')
    };
    var vIcon = modal.querySelector('[data-bpc-verdict-icon]');
    var vTitle = modal.querySelector('[data-bpc-verdict-title]');
    var vText = modal.querySelector('[data-bpc-verdict-text]');
    var atcBtn = modal.querySelector('[data-bpc-atc]');
    var retryBtn = modal.querySelector('[data-bpc-retry]');
    var qtyRow = modal.querySelector('[data-bpc-qty-row]');
    var qtyInput = modal.querySelector('[data-bpc-qty-input]');
    var qtyMinus = modal.querySelector('[data-bpc-qty-minus]');
    var qtyPlus = modal.querySelector('[data-bpc-qty-plus]');

    // Fill static labels.
    modal.querySelectorAll('[data-bpc-i18n]').forEach(function (el) {
      var k = el.getAttribute('data-bpc-i18n');
      if (t[k]) el.textContent = t[k];
    });
    var atcLabel = modal.querySelector('[data-bpc-cta-label]');
    if (atcLabel) atcLabel.textContent = t.cta; else atcBtn.textContent = t.cta;
    retryBtn.textContent = t.retry;

    function getQty() {
      var n = parseInt(qtyInput && qtyInput.value, 10);
      if (!n || n < 1) n = 1;
      return n;
    }
    function setQty(n) {
      if (n < 1) n = 1;
      if (qtyInput) qtyInput.value = String(n);
    }

    function showStep(name) {
      Object.keys(steps).forEach(function (k) {
        if (steps[k]) steps[k].hidden = k !== name;
      });
      steps.result.classList.remove('bpc-step--pass');
    }

    function open() {
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      showStep('intro');
      // Funnel top: photo tool actually opened (distinct from the info popup's
      // balcony_check_opened). Lets us measure open -> upload drop-off.
      gaEvent('balcony_check_tool_opened', { product_id: product.id, product_name: product.name });
    }
    function close() {
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      reset();
    }
    function reset() {
      fileInput.value = '';
      previews.forEach(function (img) { img.removeAttribute('src'); });
      showStep('intro');
    }

    // Downscale + compress in-browser (also strips EXIF, keeps orientation).
    function compress(file) {
      return new Promise(function (resolve, reject) {
        var finish = function (bitmap, w, h) {
          var scale = Math.min(1, MAX_DIM / Math.max(w, h));
          var cw = Math.round(w * scale);
          var ch = Math.round(h * scale);
          var canvas = document.createElement('canvas');
          canvas.width = cw;
          canvas.height = ch;
          canvas.getContext('2d').drawImage(bitmap, 0, 0, cw, ch);
          resolve(canvas.toDataURL('image/jpeg', JPEG_QUALITY));
        };
        if (window.createImageBitmap) {
          try {
            createImageBitmap(file, { imageOrientation: 'from-image' })
              .then(function (bm) { finish(bm, bm.width, bm.height); })
              .catch(function () { fallback(); });
          } catch (e) { fallback(); }
        } else {
          fallback();
        }
        function fallback() {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () { URL.revokeObjectURL(url); finish(img, img.naturalWidth, img.naturalHeight); };
          img.onerror = function () { URL.revokeObjectURL(url); reject(new Error('decode')); };
          img.src = url;
        }
      });
    }

    function renderVerdict(category) {
      var v = VERDICTS[category] || VERDICTS.unclear;
      vIcon.textContent = v.icon;
      vTitle.textContent = t[v.title];
      vText.textContent = t[v.text];
      if (v.pass) {
        steps.result.classList.add('bpc-step--pass');
        atcBtn.hidden = false;
        setQty(1);
        if (qtyRow) qtyRow.hidden = false;
      } else {
        atcBtn.hidden = true;
        if (qtyRow) qtyRow.hidden = true;
      }
      showStep('result');
    }

    function classify(dataUrl) {
      if (!endpoint) { renderVerdict('error'); return; }
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ image: dataUrl })
      })
        .then(function (r) {
          if (r.status === 429) return { _rate: true };
          return r.ok ? r.json() : Promise.reject(new Error('http'));
        })
        .then(function (data) {
          if (data && data._rate) { renderVerdict('rate'); return; }
          var cat = (data && data.category) || 'unclear';
          gaEvent('balcony_check_result', {
            result: fitsLabel(cat), category: cat,
            product_id: product.id, product_name: product.name
          });
          renderVerdict(cat);
        })
        .catch(function () { renderVerdict('error'); });
    }

    function handleFile(file) {
      // Don't filter on file.type — mobile pickers often report an empty or
      // non-standard type. If it isn't a decodable image, compress() fails and
      // we show the error step (not a silent no-op).
      if (!file) return;
      // Per-visitor daily cap: block a further upload with the 🔒 limit screen.
      // Disabled when MAX_PER_USER is 0 (global daily cap + rate limiter still apply).
      if (MAX_PER_USER > 0) {
        if (getUses() >= MAX_PER_USER) { renderVerdict('limit'); return; }
        bumpUses();
      }
      gaEvent('balcony_check_upload', { product_id: product.id, product_name: product.name });
      showStep('loading');
      compress(file)
        .then(function (dataUrl) {
          previews.forEach(function (img) { img.src = dataUrl; });
          classify(dataUrl);
        })
        .catch(function () { renderVerdict('error'); });
    }

    function triggerAddToCart() {
      var qty = getQty();
      // Push the chosen amount onto the PDP quantity field so the existing
      // add-to-cart button adds the right number (variant/cart logic intact).
      var pdpQty =
        document.querySelector('input[name="quantity"].vercony-qty-input') ||
        document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      if (pdpQty) {
        pdpQty.value = String(qty);
        pdpQty.dispatchEvent(new Event('input', { bubbles: true }));
        pdpQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      gaEvent('balcony_check_add_to_cart', { product_id: product.id, product_name: product.name, quantity: qty });
      var btn =
        document.querySelector('.vercony-atc-btn') ||
        document.querySelector('form[action*="/cart/add"] [type="submit"], button[name="add"]');
      if (btn) btn.click();
      close();
    }

    // Wiring
    triggers.forEach(function (el) { el.addEventListener('click', open); });
    modal.querySelectorAll('[data-bpc-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') close();
    });
    fileInput.addEventListener('change', function () {
      var f = fileInput.files && fileInput.files[0];
      handleFile(f);
      fileInput.value = ''; // allow re-picking the same photo
    });
    retryBtn.addEventListener('click', reset);
    atcBtn.addEventListener('click', triggerAddToCart);
    if (qtyMinus) qtyMinus.addEventListener('click', function () { setQty(getQty() - 1); });
    if (qtyPlus) qtyPlus.addEventListener('click', function () { setQty(getQty() + 1); });

    // Daily-cap fallback: if the global cap is reached, hide the photo CTA (and
    // its lead-in) so only the info popup link remains. Fail open on error.
    if (endpoint) {
      fetch(endpoint, { method: 'GET' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (s) {
          if (s && s.open === false) {
            document.querySelectorAll('.bpc-mobile-only').forEach(function (el) {
              el.style.display = 'none';
            });
          }
        })
        .catch(function () {});
    }
  }

  function boot() {
    document.querySelectorAll('.bpc-modal').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
